import React from 'react';
import { motion } from 'framer-motion';
import { Check, Flame, ThermometerSun, Snowflake, Wind, Wrench } from 'lucide-react';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function HeaterHire() {
  const features = ['Fan assisted & IDF heaters', 'Wide temperature range', 'Same day delivery (before 12pm)', 'Office/factory/event applications', 'Expert guidance available', 'Nationwide coverage'];
  const relatedServices = [{
    title: 'Boiler Hire',
    icon: Flame,
    path: '/boiler-hire'
  }, {
    title: 'Chiller Hire',
    icon: Snowflake,
    path: '/chiller-hire'
  }, {
    title: 'Cooling Hire',
    icon: Wind,
    path: '/cooling-hire'
  }, {
    title: 'Ancillaries',
    icon: Wrench,
    path: '/ancillaries'
  }];
  return <main className="flex-grow" data-id="element-445">
      <ServicePageHero title="Portable Heater Hire" subtitle="Fast, effective temporary heating solutions for any environment." bgImage="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-Fleet.webp" data-id="element-446" />

      <section className="py-20 bg-white" data-id="element-447">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-448">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-449">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2" data-id="element-450">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-6" data-id="element-451">
                Versatile Heating Solutions
              </h2>

              <div className="space-y-4 text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-452">
                <p data-id="element-453">
                  Browse our selection of fan assisted and indirect diesel fired
                  (IDF) heaters, available for hire across the UK. Our portable
                  heaters cover a wide range of temperatures required for
                  various applications and sectors.
                </p>
                <p data-id="element-454">
                  So whether it's an office, factory or an event that you
                  require the equipment for, we have you covered. If you're
                  unsure about the number of heaters or the type of heater you
                  require, our friendly team can provide guidance on finding you
                  the best solution.
                </p>
                <p data-id="element-455">
                  All of our heaters can be dispatched and installed very
                  quickly too.{' '}
                  <strong data-id="element-456">
                    Same day delivery on all portable heaters when an order is
                    confirmed before 12pm.
                  </strong>
                </p>
                <p data-id="element-457">
                  So if it's an emergency and you require the equipment ASAP, we
                  would suggested calling us on{' '}
                  <a href="tel:08004647025" className="font-bold text-brand-dark hover:text-brand-green transition-colors" data-id="element-458">
                    0800 464 7025
                  </a>
                  .
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-459">
                {features.map((feature, i) => <div key={i} className="flex items-start" data-id="element-460">
                    <div className="bg-brand-green/20 p-1 rounded-full mr-3 mt-1 flex-shrink-0" data-id="element-461">
                      <Check className="w-4 h-4 text-brand-dark" data-id="element-462" />
                    </div>
                    <span className="text-sm font-medium text-brand-dark" data-id="element-463">
                      {feature}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2 sticky top-24" data-id="element-464">
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-Fleet.webp" alt="Rapid Energy Fleet" className="rounded-2xl shadow-2xl w-full object-cover h-[500px]" data-id="element-465" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-16 bg-brand-light" data-id="element-466">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-467">
          <h3 className="text-2xl font-heading font-bold text-brand-dark mb-8 text-center" data-id="element-468">
            Related Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-469">
            {relatedServices.map((service, index) => <Link key={index} to={service.path} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group flex flex-col items-center text-center" data-id="element-470">
                <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand-green/20 transition-colors" data-id="element-471">
                  <service.icon className="w-6 h-6 text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-472" />
                </div>
                <h4 className="font-heading font-bold text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-473">
                  {service.title}
                </h4>
              </Link>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-474" />
    </main>;
}